import * as React from 'react';
import Modal from 'antd/lib/modal';
import Avatar from 'antd/lib/avatar';
import Form from 'antd/lib/form';
import { WrappedFormUtils, FormComponentProps } from 'antd/lib/form/Form';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Button from 'antd/lib/button';
import { ReactComponent as Password } from '../Assets/images/password.svg';
import './ForgetPassword.scss';
import { IStateApp } from '../Reducers/index';
import { connect } from 'react-redux';
import { EStatusRequest } from '../Reducers/Session/index';
import notification from 'antd/lib/notification';
import { createActionStatus } from '../Actions/Session/Actions';
import Loading from './Loading';
import TextField from '@material-ui/core/TextField';

export interface IForgetPasswordword extends FormComponentProps {
	isOpen?: boolean;
	onChange: (data: any) => void;
	onClose: () => void;
	status: EStatusRequest,
	error?: any;
	onChangeStatus: (status: EStatusRequest) => void;
}

interface FormChangeProps extends FormComponentProps {
	onChange: (data: any) => void;
	style?: any;
}

const FormChange = (props: FormChangeProps) => {
	const { getFieldDecorator, getFieldValue } = props.form;
	const hasError = (form: WrappedFormUtils, name: string) => {
		const err = form.getFieldError(name);
		if (err === undefined) {
			return false;
		}
		if (err.length === 0) {
			return false;
		}
		return true;
	};
	const getError = (form: WrappedFormUtils, name: string) => {
		const err = form.getFieldError(name);
		return err;
	};
	let invalid = getFieldValue('passwordNew') !== getFieldValue('passwordConfirm');

	const onSend = (evt: any) => {
		evt.preventDefault();
		props.form.validateFields((error, values) => {
			if (error || invalid) {
				return;
			}
			props.onChange(values)
		})
	}
	return (
		<Form onSubmit={onSend}>
			<div className='ForgetPassword'>
				<div className='ForgetPassword-Header'>
					<Password />
					<h2>¿Se te olvidó tu contraseña?</h2>
					<p>
						Para recuperar su contraseña ingrese correo electrónico registrado y a continuación le enviaremos los pasos para restablecerla.
					</p>
				</div>
				<div className='ForgetPassword-Body'>

					<FormControl
						style={{ width: '100%' }}
						error={hasError(props.form, 'email') || invalid}>
						<div>
							<Avatar icon='user' />
						</div>
						<div style={{ flex: '1 auto' }}>
							{getFieldDecorator('email', {
								rules: [
									{
										required: true,
										message: 'El correo es requerido'
									},
									{
										type: 'email',
										message: 'Debe escribir un correo valido'
									}
								]
							})(
								<TextField
									label='Correo corporativo'
									variant='outlined'
									margin='normal'
								/>
							)}
							{(hasError(props.form, 'email')) && (
								<FormHelperText>
									{getError(props.form, 'email')}
								</FormHelperText>
							)}
						</div>
					</FormControl>
				</div>
				<div className='ForgetPassword-Footer'>
					<Button htmlType="submit" type='primary'>Recuperar Contraseña</Button>
				</div>
			</div>
		</Form>
	);
};
const ForgetPassword = (props: IForgetPasswordword) => {
	const isComplete = props.status === EStatusRequest.COMPLETE || props.status === EStatusRequest.FAIL;
	if (isComplete) {
		props.onChangeStatus(EStatusRequest.PENDING);
		if (props.status === EStatusRequest.COMPLETE) {
			notification.success({
				message: "Recuperación de contraseña",
				description: "Verifique su correo para recuperar su contraseña"
			});
			props.onClose();
		} else {
			const extra = props.error && 'detail' in props.error ? props.error.detail === 'Validation' ? 'Contraseña Actual incorrecta' : props.error.detail : props.error;
			notification.error({
				message: "Recuperación de contraseña",
				description: "Error recuperando contraseña, " + extra
			});
		}
	}
	return (
		<Modal width={580} footer={false} onCancel={props.onClose} visible={props.isOpen}>
			{props.status === EStatusRequest.PROCESS && <Loading />}
			<FormChange style={{ display: props.status === EStatusRequest.PROCESS ? 'none' : 'block' }} onChange={props.onChange} {...props} />
		</Modal>
	);
};

const mapProps = (state: IStateApp) => ({
	status: state.session.status,
	error: state.session.error
})

const mapActions = {
	onChangeStatus: createActionStatus
};

export const ForgetPasswordword = Form.create<IForgetPasswordword>()(ForgetPassword);

export default connect(mapProps, mapActions)(ForgetPasswordword);
